import { HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn, Router } from '@angular/router';
import { forkJoin, of } from 'rxjs';
import { catchError, map, take } from 'rxjs/operators';

import { ValToastService } from '@valamar/val-toast';
import { AccountInterface } from '../interfaces/vrc/account.interface';
import { ValUtilsService } from './val-utils.service';
import { VrcAccountUtilsService } from './vrc-account-utils.service';
import { VrcDataService } from './vrc-data.service';
import { VrcStorageService } from './vrc-storage.service';

export const vrcOfferResolver: ResolveFn<boolean> =
  (route: ActivatedRouteSnapshot) => {
    const _srvc = inject(VrcDataService);
    const _r = inject(Router);
    const _ms = inject(ValToastService);
    const _st = inject(VrcStorageService);
    const _u = inject(ValUtilsService);
    const _au = inject(VrcAccountUtilsService);
    const offerId = route.params['id'];
    const accountId = route.params['accountId'];
    _ms.info({ title: 'Loading', message: 'Loading offer', position: 'bottom-right', autoCloseMs: 3000 });
    if (!_st.editModel()) {
      return forkJoin([
        _srvc.getOffer(offerId).pipe(
          take(1),
          map(x => {
            _st.offer.set(x);
            _ms.clearAll();
            return true;
          })
        ),
        _srvc.getAccountById(accountId).pipe(
          take(1),
          map(acc => {
            // model fix   
            if (acc) {
              acc = <AccountInterface>_au.AccountFix(acc);
              const editModel = _au.mapAccountToEditAccount(acc);
              _st.editModel.set(editModel);
              _st.origModel = acc;
              _st.loyality = acc.loyaltiesList;
              _st.loyalityOrig = _u.deepCopyObject(acc.loyaltiesList);
              _st.isEditOn.set(false);
              _au.UpdateCommunicationAccountData();
              _st.selectedLoyaltyNumber.set(_st.editModel()?.loyaltiesList.filter(x => !x.cardInformation?.cardNumber?.startsWith("4")).map(x => x.cardInformation?.cardNumber).reduceRight((_a, b) => b, null) ?? null);
              _st.selectedValamartistNumber.set(_st.editModel()?.loyaltiesList.filter(x => x.cardInformation?.cardNumber?.startsWith("4")).map(x => x.cardInformation?.cardNumber).reduceRight((_a, b) => b, null) ?? null);
              const phones = _au.mapAccountToPhones(acc);
              const emails = _au.mapAccountToEmails(acc);
              _st.emails.set(emails);
              _st.phones.set(phones);
            }

            _ms.clearAll();
            return true;
          })
        )
      ]
      ).pipe(take(1),
        map(() => true),
        catchError((err: HttpErrorResponse) => {
          _ms.danger({ title: 'Error', message: err?.error?.message, position: 'bottom-right', autoCloseMs: 3000 });
          if (_st.origModel) {
            _r.navigate(['main/account/' + _st.origModel.id]);
          } else {
            _r.navigate(['main']);
          }
          return of(false);
        }));
    }

    return _srvc.getOffer(offerId).pipe(
      take(1),
      map(x => {
        _st.offer.set(x);
        _ms.clearAll();
        return true;
      }),
      catchError((err: HttpErrorResponse) => {
        _ms.danger({ title: 'Error', message: err?.error?.message, position: 'bottom-right', autoCloseMs: 3000 });
        if (_st.origModel) {
          _r.navigate(['main/account/' + _st.origModel.id]);
        } else {
          _r.navigate(['main']);
        }
        return of(false);
      })
    );
  };
